import EachSquareResults from '../EachSquareResults';

const CardsSection = ({ data }) => {
    return (
        <div className='cards-section'>
            <div className='cards-section__row'>
                <EachSquareResults
                    title="INCIDENCIAS TOTALES MES"
                    results={data.incidencias}
                />
                <EachSquareResults
                    title="INCIDENCIAS TIEMPO MEDIO"
                    results={data.incidencias_tiempo}
                    className='incidencias-tiempo-medio'
                />
                {['semana', 'hoy', 'mes'].map((rowName) => (
                    <EachSquareResults
                        title={rowName.toUpperCase()}
                        results={data[`presupuestos_${rowName}`]}
                        key={rowName}
                    />
                ))}
            </div>
            <div className='cards-section__row'>
                <EachSquareResults
                    title="INCIDENCIAS EXPERIENCIA"
                    results={data.incidencias_experiencia}
                />
                <EachSquareResults
                    title="PIEZA NO ENCONTRADA"
                    results={data?.pieza_no_encontrada}
                />
                {['semana', 'dia', 'mes'].map((rowName) => (
                    <EachSquareResults
                        title={`${rowName.toUpperCase()} RECORD`}
                        results={data[`record_${rowName}`]['total']}
                        extraInfo={data[`record_${rowName}`]['fecha']}
                    />
                ))}
            </div>
        </div>
    );
};

export default CardsSection;
